import usePermission, { checkForPermission } from './usePermission';

const paymentsPermissionName = 'payments';

export const checkForPaymentsPermission = (user) => checkForPermission(user, paymentsPermissionName);

const usePaymentsPermission = () => usePermission(paymentsPermissionName);

export default usePaymentsPermission;
